import axios from "axios";
import type { Vendor } from "types/vendor";
import { VENDOR_FORM_INITIAL, VendorFormData } from "./vendorFormTypes";
import type { VendorIntegrationType } from "./VendorIntegrationPanel";

export function vendorToFormData(vendor: Vendor): VendorFormData {
  return {
    vendor_name: vendor.vendor_name ?? "",
    prefix: vendor.prefix ?? "",
    first_name: vendor.first_name ?? "",
    last_name: vendor.last_name ?? "",
    suffix: vendor.suffix ?? "",
    phone_type: vendor.phone_type ?? "",
    phone_number: vendor.phone_number ?? "",
    ext: vendor.ext ?? "",
    email_type: vendor.email_type ?? "",
    email_address: vendor.email_address ?? "",
    job_title: vendor.job_title ?? "",
    department: vendor.department ?? "",
    street_address: vendor.street_address ?? "",
    unit: vendor.unit ?? "",
    address_line_2: vendor.address_line_2 ?? "",
    city: vendor.city ?? "",
    zip_code: vendor.zip_code ?? "",
    vendor_state: vendor.vendor_state ?? "",
    notes: vendor.notes ?? "",
    payment_term: vendor.payment_term ?? "",
    distributor_type_code: vendor.is_heritage
      ? "heritage"
      : vendor.is_siteone
        ? "siteone"
        : "",
  };
}

export function getIntegrationTypeFromVendor(vendor: Vendor | null | undefined): VendorIntegrationType {
  if (!vendor) return "";
  if (vendor.is_heritage) return "heritage";
  if (vendor.is_siteone) return "siteone";
  return "";
}

export function buildAddressObjFromVendor(vendor: Vendor) {
  return {
    address: vendor.street_address ?? "",
    isStandardizedAddress: Boolean(vendor.is_standardized_address),
    selectedOption: {
      description: vendor.street_address ?? "",
      city: vendor.city ?? "",
      state: vendor.vendor_state ?? "",
      zipcode: vendor.zip_code ?? "",
    },
  };
}

export async function saveVendorHeritageBranch(vendorId: number, branchId: number): Promise<void> {
  await axios.put(
    `${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/${vendorId}/heritage/settings`,
    { branchId }
  );
}

export async function syncVendorIntegration(
  vendorId: number,
  previousType: VendorIntegrationType,
  nextType: VendorIntegrationType
): Promise<void> {
  if (previousType === nextType) return;

  if (previousType === "heritage" && nextType !== "heritage") {
    await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/heritage/deauthorize`, {
      vendorId,
    });
  }

  if (nextType === "heritage" && previousType !== "heritage") {
    await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/heritage/authorize`, {
      vendorId,
    });
  }
}

export function resetFormState() {
  return {
    vendorData: { ...VENDOR_FORM_INITIAL },
    addressObj: {
      address: "",
      isStandardizedAddress: false,
      selectedOption: { description: "", city: "", state: "", zipcode: "" },
    },
  };
}
